/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TaxType = {
    Vat: 'VAT',
    Irpf: 'IRPF',
    Other: 'OTHER'
} as const;
export type TaxType = typeof TaxType[keyof typeof TaxType];


export function instanceOfTaxType(value: any): boolean {
    for (const key in TaxType) {
        if (Object.prototype.hasOwnProperty.call(TaxType, key)) {
            // @ts-ignore
            if (TaxType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TaxTypeFromJSON(json: any): TaxType {
    return TaxTypeFromJSONTyped(json, false);
}

export function TaxTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxType {
    return json as TaxType;
}

export function TaxTypeToJSON(value?: TaxType | null): any {
    return value as any;
}

